import styled from 'styled-components'

// Container for the entire page
export const HomeContainer = styled.div`
  display: flex;
  background-color: ${props => props.bgColor};
  min-height: 100vh;
`

// Sticky container for sidebar
export const HomeStickyContainer = styled.div`
  width: 20%;
  position: sticky;
  top: 0;
`

// Main content container next to the sidebar
export const HomeSideContainer = styled.div`
  width: 80%;
  background-color: ${props => props.bgColor};
  padding: 20px;
`

// Container for search and video cards
export const SearchVideosContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`

// Container for all videos
export const VideosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  background-color: ${props => props.bgColor};
`

// Container for the trending section header
export const TrendingHeadContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`

// Logo for trending section
export const TrendingLogo = styled.div`
  font-size: 24px;
  color: red;
  margin-right: 10px;
`

// Styled heading for trending or saved videos
export const Heading = styled.h1`
  color: ${props => props.textColor};
  font-size: 24px;
`

// Container for when no saved videos are found
export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bgColor};
  height: 100%;
  text-align: center;
`

// Image for "no saved videos" case
export const Image = styled.img`
  width: 300px;
  margin-bottom: 20px;
`

// Description text for "no saved videos"
export const Desc = styled.p`
  color: ${props => props.textColor};
  font-size: 18px;
`
